import { Button, SceneWrapper, Typography } from '~/components';
import { getTheme, pxToRem, styled } from '~/modules';
import { mqDevices } from '~/utils';

const backgroundZ4 = getTheme('background.z4');
const backgroundZ3 = getTheme('background.z3');

const spacingXs = getTheme('spacing.xs');
const spacingMd = getTheme('spacing.md');
const spacingLg = getTheme('spacing.lg');
const spacingXl = getTheme('spacing.xl');
const spacingXxl = getTheme('spacing.xxl');

const themeRadiusCard = getTheme('themeRadius.card');

export const Wrapper = styled(SceneWrapper)`
  flex: 1;
`;

export const Content = styled.div`
  @media ${mqDevices.inMobileAndTablet} {
    flex-direction: column;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: ${spacingXxl}px 0;
  height: auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export const UserInfoColumn = styled.div`
  flex-direction: column;
  flex: 1;
  max-width: ${pxToRem(400)};

  @media ${mqDevices.inMobileAndTablet} {
    max-width: 100%;
  }
`;

export const ContentColumn = styled.div`
  flex: 1;
  flex-direction: column;
  margin-left: ${spacingLg}px;
  display: table;

  @media ${mqDevices.inMobileAndTablet} {
    margin-left: 0;
    margin-top: ${spacingXxl}px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacingMd}px;
  margin-bottom: ${spacingLg}px;
  align-items: center;
  justify-content: space-between;
`;

export const ActionsTitle = styled(Typography).attrs({ variant: 'max' })`
  font-weight: bold;
`;

export const ExportPDFButton = styled(Button)`
  gap: ${spacingMd}px;
`;

export const Card = styled.div`
  width: 100%;
  height: auto;
  flex-direction: column;
  padding: ${spacingLg}px;
  background-color: ${backgroundZ4};
  border-radius: ${themeRadiusCard}px;
  margin-bottom: ${spacingXl}px;
  gap: ${spacingMd}px;

  @media ${mqDevices.inMobileAndTablet} {
    max-width: 100%;
  }
`;

export const SmallCard = styled.div`
  font-weight: 500;
  opacity: 0.8 !important;
  background-color: ${backgroundZ3};
  border-radius: ${themeRadiusCard}px;
  padding: ${spacingMd}px;
  flex: 1 1 250px;
  flex-direction: column;
`;

export const SmallCardWrapper = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacingMd}px;
`;

export const Label = styled(Typography).attrs({
  variant: 'xs',
})`
  font-weight: 700;
  opacity: 0.5 !important;
  margin-bottom: ${spacingXs}px;
`;

export const DescriptionLabel = styled(Typography).attrs({ variant: 'xs' })`
  font-weight: 500;
  white-space: pre-wrap;
  word-break: break-all;
`;
